import { render, staticRenderFns } from "./copyCompanyTable.vue?vue&type=template&id=5a709704&scoped=true&"
import script from "./copyCompanyTable.vue?vue&type=script&lang=js&"
export * from "./copyCompanyTable.vue?vue&type=script&lang=js&"
import style0 from "./copyCompanyTable.vue?vue&type=style&index=0&id=5a709704&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a709704",
  null
  
)

export default component.exports